module.exports = __webpack_public_path__ + "img/fondo-banner-principal.5d69b7b8.svg";